<template>
<div
    :class="`name-${name}`"
    class="icon-container"
>
    <template v-if="name === 'PortalIcon'">
    <svg class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path class="st0" d="M49.804,19.581c-16.982,0-30.8,13.817-30.8,30.8s13.817,30.8,30.8,30.8s30.8-13.817,30.8-30.8	S66.787,19.581,49.804,19.581z M20.992,50.381c0-15.888,12.925-28.812,28.812-28.812s28.812,12.925,28.812,28.812	c0,7.342-2.764,14.047-7.302,19.141c-3.651-5.435-9.117-9.145-15.354-10.553c5.151-2.35,8.746-7.535,8.746-13.556	c0-8.217-6.686-14.903-14.903-14.903s-14.903,6.686-14.903,14.903c0,6.16,3.758,11.459,9.1,13.727	c-6.189,1.601-11.642,5.515-15.122,11.017C23.996,64.992,20.992,58.033,20.992,50.381z M49.804,58.329	c-7.122,0-12.916-5.794-12.916-12.916s5.794-12.916,12.916-12.916S62.72,38.292,62.72,45.413S56.926,58.329,49.804,58.329z	 M30.326,71.589c4.217-6.96,11.829-11.273,19.975-11.273c8.011,0,15.276,3.983,19.602,10.68c-5.195,5.067-12.287,8.197-20.099,8.197	C42.3,79.193,35.459,76.307,30.326,71.589z"/></svg>
    </template>
</div>
</template>

<script>
  export default {
    name: 'page-top-svg-icons',
    props: {
      name: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon-container{
    display:flex;
}
</style>
